class DisclosureComponent extends HTMLElement {
  get button() {
    return this.querySelector('button');
  }

  connectedCallback() {
    this.button?.addEventListener(
      'click',
      () => {
        this.setAttribute('open', '');
      },
      { once: true } // no need to listen anymore after initial click
    );
  }
}

if (!window.customElements.get('tmp-disclosure')) {
  window.DisclosureComponent = DisclosureComponent;
  window.customElements.define('tmp-disclosure', DisclosureComponent);
}
